var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpanelLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 407.66 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff6c2c;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cPanelAsset 8@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.69,59.1h67.8L147,99.3a25.38,25.38,0,0,1-9,13.5,24.32,24.32,0,0,1-15.3,5.1H91.19a30.53,30.53,0,0,0-19,6.3,33,33,0,0,0-11.55,17.1,31.91,31.91,0,0,0-.45,15.3A33.1,33.1,0,0,0,66,169.35a30.29,30.29,0,0,0,10.8,8.85,31.74,31.74,0,0,0,14.4,3.3h19.2a10.8,10.8,0,0,1,8.85,4.35,10.4,10.4,0,0,1,2,9.75l-12,44.4h-21a84.77,84.77,0,0,1-39.75-9.45A89.78,89.78,0,0,1,18.29,205.5,88.4,88.4,0,0,1,1.94,170,87.51,87.51,0,0,1,3,129l1.2-4.5A88.69,88.69,0,0,1,35.84,77.25a89.91,89.91,0,0,1,25-13.35A87,87,0,0,1,89.69,59.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.89,240,183,18.6a25.38,25.38,0,0,1,9-13.5A24.28,24.28,0,0,1,207.29,0H270a84.8,84.8,0,0,1,39.75,9.45,89.21,89.21,0,0,1,46.65,60.6,83.8,83.8,0,0,1-1.2,41l-1.2,4.5a89.88,89.88,0,0,1-12,26.55,87.65,87.65,0,0,1-73.2,39.15h-54.3l10.8-40.5a25.38,25.38,0,0,1,9-13.2,24.32,24.32,0,0,1,15.3-5.1H267a31.56,31.56,0,0,0,30.6-23.7A29.5,29.5,0,0,0,298,84a33.1,33.1,0,0,0-5.85-12.75,31.85,31.85,0,0,0-10.8-9A30.61,30.61,0,0,0,267,58.8h-33.6l-43.8,162.9a25.38,25.38,0,0,1-9,13.2,23.88,23.88,0,0,1-15,5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M361.18,32.31h-3.71V3.71h-10.1V.42h23.91V3.71h-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M390.19,32.31,379.37,4h-.17q.3,3.36.3,8V32.31h-3.42V.42h5.58l10.1,26.3h.18L402.12.42h5.54V32.31H404V11.76c0-2.36.11-4.91.31-7.68h-.17L393.18,32.31Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpanelLogo);
export default __webpack_public_path__ + "static/media/cpanel-logo.7c4ee546f8f3abeca5a46039b42476a0.svg";
export { ForwardRef as ReactComponent };